export const cachen = {
  batchRights: {}
};